// i18n area 'cluster' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.lt-LT.meta.json.
import type { enUS } from './cluster'

export const ltLT: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantinės prieigos',
      subtitle: 'Mazgo aptarnavimo durys: tik skaitymo prieiga su laikinu slaptažodžiu ir avarinė paskyra su seifo slaptažodžiu',
      readOnlyTitle: 'Tik skaitymo prieiga (trantor)',
      stateNone: 'uždaryta',
      stateGranted: 'atvira',
      stateGrantedPending: 'suteikta — taikoma mazge',
      grantedBy: 'Suteikė',
      grantedAt: 'Suteikta',
      expiresAt: 'Baigiasi',
      reason: 'Priežastis',
      endedAt: 'Uždaryta',
      endedReason: {
        revoked: 'atšaukta',
        expired: 'pasibaigusi (TTL)',
        reboot: 'mazgo perkrovimas',
        failed: 'nepritaikyta (užduotis nepavyko)'
      },
      grant: 'Suteikti tik skaitymo prieigą…',
      grantTitle: 'Suteikti tik skaitymo prieigą',
      grantSubmit: 'Suteikti',
      grantError: 'Suteikimas buvo atmestas',
      grantConfirm: 'TVirt sugeneruoja laikiną slaptažodį sistemos naudotojui «trantor» (tik skaitymas: journal ir diagnostika, be sudo) ir nustato jį mazge užduotimi. Slaptažodis rodomas TIK vieną kartą, patvirtinant; jis nustoja galioti pasibaigus terminui, atšaukus arba per kitą mazgo perkrovimą.',
      reasonLabel: 'Priežastis',
      reasonHint: 'Kodėl atidarote duris: tai lieka suteikime, audite ir žurnale',
      ttlLabel: 'Trukmė',
      ttlHours: '{n} val.',
      revoke: 'Atšaukti tik skaitymo prieigą…',
      revokeTitle: 'Atšaukti tik skaitymo prieigą',
      revokeSubmit: 'Atšaukti',
      revokeError: 'Atšaukimas buvo atmestas',
      revokeConfirm: 'Suteikimas baigiasi iš karto ir užduotis vėl užrakina naudotoją «trantor» mazge: laikinas slaptažodis nustoja veikti.',
      passwordTitle: 'Tik skaitymo slaptažodis',
      passwordOnce: 'Šis slaptažodis rodomas TIK vieną kartą: nukopijuokite jį dabar. Jis niekur nesaugomas ir jo nebus galima perskaityti dar kartą — jei jį prarasite, suteikite iš naujo.',
      passwordUser: 'Naudotojas',
      passwordLabel: 'Slaptažodis',
      passwordHint: 'Galioja iki {until} arba iki kito mazgo perkrovimo; tinkamas naudoti, kai suteikimo užduotis baigta. Prieiga: ssh trantor@<mazgo adresas>.',
      emergencyTitle: 'Paskutinė avarinė prieiga (trantor-emergency)',
      lastLogin: '{time} per {via} iš {from}',
      lastLoginNone: 'nepastebėta',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsolė',
        sudo: 'sudo',
        unknown: 'nežinoma'
      },
      emergencyHint: 'Avarinė paskyra «trantor-emergency» (visas sudo) visada įjungta su slaptažodžiu, sugeneruotu diegiant mazgą ir saugomu seife: TVirt jo nežino, nekeičia ir neatkuria. Kiekvienas prisijungimas pranešamas čia ir įvykių žurnale.'
    },
    nodeFirewall: {
      tab: 'Užkarda',
      title: 'Mazgų užkarda',
      subtitle: 'nftables ruleset laikysena, kurią kiekvienas mazgas taiko pats sau — vienintelė mazgo užkarda (firewalld išjungtas)',
      modeLabel: 'Laikysena',
      mode: {
        disabled: 'Išjungta — mazguose jokio ruleset',
        permissive: 'Leidžianti — skaičiuoja ir registruoja, nieko neatmeta',
        enforced: 'Taikoma — įleidžiamas tik išvestinis registras'
      },
      hint: {
        disabled: 'Kaip šiandien: mazgai neneša jokio ruleset. Perjunk į leidžiančią, kad PERSKAITYTUM, kas būtų atmesta, prieš tai atmetant.',
        permissive: 'Kiekvienas mazgas taiko savo išvestinį ruleset su policy accept: tai, ką taikoma laikysena atmestų, skaičiuojama ir registruojama (journal prefiksas „tvirt-node would-drop:“). Niekas neblokuojama.',
        enforced: 'Kiekvienas mazgas taiko savo išvestinį ruleset su policy drop: ssh ir API iš bet kur, store / live migration / overlay / Ceph tik iš narių, tinklo paslaugų listeneriai iš aptarnaujamo tinklo. Kiekvienas perjungimas yra apply su patvirtinimu — mazgas, kuriam nepavyksta patvirtinti, pats grįžta atgal.'
      },
      confirmTitle: 'Taikyti mazgų užkardą?',
      confirmBody: 'Kiekvienas mazgas taiko ruleset su patvirtinimu: iki termino per naujas taisykles zonduoja backend, store ir ssh ir patvirtina — kitaip pats grįžta prie ankstesnio ruleset. Pirmiausia perskaityk leidžiančios laikysenos skaitiklius mazguose.',
      confirmSubmit: 'Taikyti',
      confirmCancel: 'Atšaukti',
      lensTitle: 'Mazgo užkarda',
      loadError: 'Nepavyko įkelti mazgo užkardos lęšio',
      noReport: 'Iš šio mazgo dar nėra užkardos ataskaitos — worker praneš per kitą passą',
      firewalldActive: 'Šiame mazge veikia firewalld: mazgo užkarda atsisako taikytis šalia jo (pritaikyk firewalld mask)',
      conditionUnconfirmed: 'Dar nėra patvirtinto ruleset — mazgas atviras',
      conditionRolledBack: 'Paskutinis apply grįžo atgal — ta pati generacija nebandoma iš naujo, kol nepasikeis registras arba laikysena nebus perjungta dar kartą',
      lastError: 'Paskutinė klaida',
      posture: 'Laikysena',
      observedAt: 'Stebėta',
      desiredGeneration: 'Norima generacija',
      componentTitle: 'Mazgo komponentas',
      componentSubtitle: 'tvirt-node-firewall — paleidžiant taiko patvirtintą ruleset, nepatvirtintą pats grąžina atgal',
      componentAbsent: 'Komponentas dar nepranešė',
      phase: 'Fazė',
      phases: {
        none: 'Niekada netaikyta',
        applied: 'Pritaikyta — laukia patvirtinimo',
        confirmed: 'Patvirtinta',
        rolledBack: 'Grąžinta atgal'
      },
      generation: 'Generacija',
      appliedAt: 'Pritaikyta',
      confirmedAt: 'Patvirtinta',
      deadline: 'Rollback terminas',
      lastRollback: 'Paskutinis rollback',
      registryTitle: 'Išvestinis registras',
      registrySubtitle: 'Prievadai, kuriuos šis mazgas atveria, pagal klasę ir kilmę — išvesti iš klasterio, niekada neredaguojami rankomis',
      registryEmpty: 'Nieko neišvesta — laikysena išjungta be patvirtinto ruleset arba dar nėra ataskaitos',
      colClass: 'Klasė',
      colPort: 'Prievadas',
      colSource: 'Šaltinis',
      colOrigin: 'Kilmė',
      classes: {
        public: 'Vieša',
        internode: 'Tarp mazgų',
        tenant: 'Tenant'
      },
      sourceMembers: 'tik nariai',
      sourceAnywhere: 'iš bet kur',
      sourceBridge: 'ant {iface}'
    },
    derivationDerived: 'išvestas',
    derivationDiverged: 'nukrypęs',
    derivationDerivedTip: 'Tinklo dokumentas IŠVESTAS iš fabric {fabric} ir vis dar sutampa su renderiu esamais įvestimis — spustelėkite derivacijos planui.',
    derivationDivergedTip: 'Derivacija iš fabric {fabric} pasikeitė po paskutinio apply (fabric, kabeliai, rolės ar nuorodos) — spustelėkite laukiančiam diff.',
    derivationRetiring: {
      one: '{n} adresas tuštinamas',
      few: '{n} adresai tuštinami',
      many: '{n} adreso tuštinama',
      other: '{n} adresų tuštinama'
    },
    standaloneHint: 'Šis mazgas neturi klasterio: jis dar nebuvo įdiegtas. Klasteriai kuriami ARBA į juos įstojama diegimo metu — nario Serverių lentelėje sugeneruotas token perduodamas diegimo programai (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Tavo teisės apima scope, o ne visą klasterį: parko inventorius — mazgai, nustatymai ir įrenginiai — matomas tik klasterio administratoriams.',
    phaseReady: 'Parengtas',
    phaseForming: 'Formuojamas',
    storeMembers: 'Store nariai',
    watermark: 'Konvergencijos riba',
    configGeneration: 'Konfigūracijos generacija',
    converged: 'suderinta',
    behind: 'atsilieka — {m} / {n}',
    revision: 'Revizija',
    rolesTitle: 'Tinklo rolės',
    rolesSubtitle: 'Kiekvienos srauto klasės adresai pagal narį — pats ryšys gyvena host tinkle',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'paveldi management',
    settingsTitle: 'Nustatymai',
    settingsSubtitle: 'Viso klasterio saugumo politika — kiekvienas mazgas ją vertina iš savo vietinės replikos',
    taskRetentionTitle: 'Task saugojimas',
    taskRetentionSubtitle: 'Vieningas GC visiems task — užbaigti task, peržengę amžiaus arba kiekio ribą, surenkami, vykdomieji – niekada',
    taskRetentionMaxAge: 'Didžiausias amžius (dienomis)',
    taskRetentionMaxCount: 'Didžiausias task skaičius',
    eventRetentionTitle: 'Įvykių saugojimas',
    eventRetentionSubtitle: 'Žurnalo GC — nuo užduočių nepriklausoma politika: užduotis yra eilė, įvykis yra atmintis',
    eventRetentionMaxAge: 'Didžiausias amžius (dienos)',
    eventRetentionMaxCount: 'Didžiausias saugomų įvykių skaičius',
    spaceThresholdsTitle: 'Vietos slenksčiai',
    spaceThresholdsSubtitle: 'Kada pildoma saugykla patenka į žurnalą (ir pranešimus)',
    spaceLowPct: 'Įspėjimas nuo (% panaudota)',
    spaceCriticalPct: 'Kritinis nuo (% panaudota)',
    spaceOrderError: 'Kritinis negali būti žemiau įspėjimo',
    spaceThresholdsHint: 'Konfigūruojami tik įėjimai: išėjimą išveda variklis, 5 punktais žemiau kiekvieno slenksčio, kad ant linijos stovinti saugykla niekada netaptų metronomu',
    failoverReserveTitle: 'Failover rezervas',
    failoverReserveSubtitle: 'N+1 priėmimo kontrolė — laisva laikoma RAM, kad klasteris po mazgų praradimo galėtų iš naujo paleisti savo krūvį',
    failoverReserveTolerate: 'Mazgai, kurių praradimą reikia toleruoti',
    failoverReserveOff: '0 — rezervas išjungtas: joks paleidimas niekada neatmetamas dėl failover talpos',
    failoverReserveOn: 'Paleidimas, kuris pažeistų rezervą, atmetamas 412 atsakymu, paaiškinančiu skaičius',
    networkShapingTitle: 'Pralaidumo teisingumas',
    networkShapingSubtitle: 'Trys kiekvieno uplink shaping medžio tipologiniai svoriai — veikia tik esant konkurencijai',
    networkShapingRest: 'Likusio srauto svoris (valdymo lygmuo, storage, replikos)',
    networkShapingOverlay: 'Overlay tinklų svoris',
    networkShapingLiveMigration: 'Live migration svoris',
    networkShapingHint: 'Garantuota dalis = svoris / trijų suma (numatyta 300 / 100 / 200, kiekvienas nuo 1 iki 10000); laisvoje jungtyje bet kuri klasė gali užimti visą pralaidumą',
    debugModeTitle: 'Debug režimas',
    debugModeSubtitle:
      'Išsamios klaidos bendruose GUI pranešimuose — kad pamatytum tikrąją priežastį, kai „nepavykęs“ veiksmas iš tikrųjų pavyko',
    debugModeLabel: 'Debug režimas įjungtas',
    debugModeOn: 'Bendri klaidos pranešimai prideda pagrindinę priežastį — vidiniai duomenys matomi kiekvienam operatoriui',
    debugModeOffHint: 'Išjungta — bendri klaidos pranešimai lieka bendri, be vidinių duomenų',
    nodeDetailsAction: 'Mazgo detalės',
    node: {
      docTitle: 'Mazgas',
      notFound: 'Mazgas nerastas',
      tabOverview: 'Apžvalga',
      tabStats: 'Statistika',
      tabNetwork: 'Tinklas',
      tabSettings: 'Vietiniai nustatymai',
      identityTitle: 'Tapatybė',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL prievadas',
      revision: 'Konfigūracijos revizija',
      versionsTitle: 'Stebėtos versijos',
      heartbeatSubtitle: 'Paskutinė būsena, kurią mazgas pranešė apie save',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU modelis',
      memoryTitle: 'Atmintis',
      hugePagesTitle: 'Milžiniški puslapiai',
      hugePagesPool: '{size}: {free} laisvi iš {total}',
      hugePagesNone: 'Telkinio nėra',
      hugePagesNoneHint: 'Mazgas neturi rezervuotų milžiniškų puslapių: jų prašančios VM čia negali pasileisti. Telkinys deklaruojamas mazge branduolio parametrais hugepagesz ir hugepages arba įrašant nr_hugepages.',
      usageTitle: 'Dabartinis naudojimas',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nestebėta — nėra šviežio mėginio',
      statsNoData: 'Intervale duomenų nėra — mazgo duomenų sekas ima pats mazgas ir pateikia jas vietoje.',
      observedTitle: 'Stebima būsena',
      observedSubtitle: 'Mazgui vietinės paslaugos ir ištekliai, kaip juos mato worker'
    },
    editRolesTitle: 'Redaguoti tinklo roles',
    memberNode: 'Mazgas',
    memberIp: 'IP adresas',
    addMember: 'Pridėti narį',
    lmInherit: 'Naudoti management adresus',
    roleIpHint: 'Narius pridėti ir šalinti galima laisvai; esamo nario IP keitimas vietoje atmetamas — IP migravimo eiga ateis vėlesniame raunde.',
    roleError: 'Nepavyko atnaujinti rolių',
    nodesTitle: 'Mazgai',
    addNodeTitle: 'Pridėti mazgą į klasterį',
    addNode: 'Pridėti mazgą',
    addNodeError: 'Nepavyko iš anksto užregistruoti mazgo',
    nodeName: 'Mazgo pavadinimas',
    nodeNameHint: 'turi sutapti su diegiant pasirinktu pavadinimu',
    nodeIp: 'Management IP',
    colName: 'Pavadinimas',
    colPhase: 'Fazė',
    colServices: 'Paslaugos',
    colWatermark: 'Watermark',
    colLastSeen: 'Paskutinis kontaktas',
    colUps: 'UPS',
    upsCordonChip: 'UPS kordonas',
    upsCordonTip: 'Mazgas pasmerkė save pagal savo UPS faktus ({time}): jis pats nuima kordoną, kai tinklas stabilus, o akumuliatorius įkrautas',
    upsUnreachable: 'UPS nepasiekiamas',
    upsOnBattery: 'Iš akumuliatoriaus',
    upsOnLine: 'Iš tinklo',
    upsLowBattery: 'žemas akumuliatoriaus lygis',
    upsNoEstimateChip: 'veikimo laikas neįvertintas',
    upsNoEstimateTip: 'UPS neskelbia veikimo laiko įverčio: mazgas pasmerkiamas tik UPS LB (žemas akumuliatorius) vėliavėle — nustatykite battery.runtime.low / LB pačiame UPS',
    upsLaneTip: 'UPS išjungimo kelias nuo {since}: pasmerkė {by}',
    upsUnit: 'įrenginys',
    upsStatus: 'NUT būsena',
    upsLoad: 'apkrova',
    upsOnBatterySince: 'iš akumuliatoriaus nuo',
    upsOnLineSince: 'iš tinklo nuo',
    upsError: 'klaida',
    upsObservedAt: 'stebėta',
    upsNone: 'joks UPS įrenginys neaptarnauja šio mazgo',
    upsBy: {
      runtime: 'veikimo laikas žemiau slenksčio',
      lowBattery: 'UPS LB vėliavėlė',
    },
    upsLane: {
      evacuate: 'evakuacija',
      local: 'išjungimas vietoje',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'svečių stabdymas',
      stoppingServices: 'paslaugų stabdymas',
      poweredOff: 'išjungtas',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS įrenginiai ir slenksčiai: mazgas pasmerkiamas, kai veikimo laikas ≤ slenkstis arba LB vėliavėlė (visada paisoma), atnaujinimas su histereze',
    upsRuntimeThreshold: 'Veikimo laiko slenkstis (s)',
    upsRuntimeThresholdHint: 'Iš akumuliatoriaus, kai numatomas veikimo laikas ≤ slenkstis, mazgas išsijungia iš eilės (numatytasis 300)',
    upsResumeStable: 'Tinklas stabilus (s)',
    upsResumeStableHint: 'Atnaujinama tik su nepertraukiamu tinklu bent tiek sekundžių (numatytasis 60)',
    upsResumeCharge: 'Minimali įkrova atnaujinant (%)',
    upsResumeChargeHint: 'Ir akumuliatorius įkrautas bent iki šio procento (numatytasis 25)',
    upsPolicyNote: 'UPS LB (žemas akumuliatorius) vėliavėlė visada pasmerkia ir jos negalima išjungti; slenksčio laikui iš akumuliatoriaus nėra. Kiekvienas įrenginys gali perrašyti tris skaičius.',
    upsUnitNew: 'naujas įrenginys',
    upsUnitSelectors: '{n} žymų parinkiklis(-iai) (tik CLI)',
    upsUnitName: 'Įrenginio pavadinimas',
    upsUnitMode: 'Režimas',
    upsModeExternal: 'išorinis (svetimas upsd)',
    upsModeManaged: 'valdomas (UPS prijungtas prie mazgo)',
    upsUnitUpsname: 'NUT pavadinimas (upsname)',
    upsUnitHost: 'upsd pagrindinis kompiuteris',
    upsUnitAttachedNode: 'Prijungtas mazgas',
    upsUnitDriver: 'NUT tvarkyklė',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Tvarkyklės įrenginys',
    upsUnitDeviceHint: 'ups.conf eilutė port=: tuščia = auto',
    upsUnitPort: 'upsd prievadas',
    upsUnitServedNodes: 'Aptarnaujami mazgai',
    upsUnitServedNodesHint: 'mazgų pavadinimai, atskirti kableliais (žymų parinkikliai eina per CLI)',
    upsUnitOverrideHint: 'tuščia = klasterio numatytasis',
    upsUnitAdd: 'Pridėti įrenginį',
    unreachableSince: 'Nepasiekiamas — paskutinis heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane dar neįgyvendino dabartinės overlay konfigūracijos',
    overlaysError: 'Paskutinis overlay suderinimo ciklas nepavyko: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Laukiama įstojimo',
      'joining': 'Įstoja',
      'member': 'Narys'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Rodomas tik dabar — nusikopijuokite iš karto, perskaityti jo daugiau nebus galima',
    copy: 'Kopijuoti',
    copied: 'Nukopijuota',
    close: 'Uždaryti',
    revokeTitle: 'Panaikinti išankstinę registraciją',
    revoke: 'Panaikinti',
    revokeError: 'Nepavyko panaikinti registracijos',
    promote: 'Paaukštinti iki store nario',
    demote: 'Pašalinti store-member rolę',
    troubleshoot: 'Trikčių šalinimas',
    promoteTitle: 'Paaukštinti iki store nario',
    demoteTitle: 'Pašalinti store-member rolę',
    promoteHint: 'Mazgas įsijungia į YugabyteDB master kvorumą. Tikram HA reikia trijų store narių.',
    demoteHint: 'Mazgas pasitraukia iš master kvorumo ir sustabdo savo store paslaugas.',
    storeError: 'Store nario keitimas buvo atmestas',
    attest: 'Patvirtinti, kad išjungtas…',
    attestTitle: 'Patvirtinti, kad mazgas išjungtas',
    attestSubmit: 'Patvirtinti, kad išjungtas',
    attestConfirm: 'Savo pačių rizika deklaruojate, kad šis mazgas išjungtas: patvirtinus iš tikrųjų veikiantį mazgą, kyla dvigubo VM vykdymo rizika. Jo task pažymimi kaip nepavykę, o jo VM authority tampa perduodamos.',
    attestError: 'Patvirtinimas buvo atmestas',
    attestedChip: 'patvirtinta, kad išjungtas',
    maintenanceChip: 'priežiūra',
    guestToolsChip: 'TVirt Guest Tools (mazgui vietinis ISO išteklius)',
    maintenanceEnter: 'Įjungti priežiūrą',
    maintenanceExit: 'Išjungti priežiūrą',
    maintenanceEnterTitle: 'Įjungti priežiūrą',
    maintenanceExitTitle: 'Išjungti priežiūrą',
    maintenanceEnterSubmit: 'Įjungti priežiūrą',
    maintenanceExitSubmit: 'Išjungti priežiūrą',
    maintenanceEnterConfirm: 'Mazgas atitveriamas ir ištuštinamas: tinklo paslaugos ir App egzemplioriai, kurių authority jis turi, perkeliami (egzemplioriai šaltai: čia sustabdyti ir nupjauti, iš naujo sukurti tiksliniame mazge — prastova), veikiančios VM migruojamos gyvai, kur įmanoma, kitaip tvarkingai sustabdomos, vykdomos užduotys baigiamos, naujas darbas laukia, o sustabdytos VM praranda savo authority — Proximity jas iš naujo išdėsto per kitą paleidimą. Pasibaigus priežiūrai niekas negrįžta savaime.',
    maintenanceExitConfirm: 'Mazgas vėl imasi darbo, o Proximity vėl svarsto jį išdėstymui. VM grįžta tik tada, kai yra paleidžiamos.',
    maintenanceError: 'Priežiūros užklausa buvo atmesta',
    maintenancePlanTitle: 'Evakuacijos planas',
    maintenancePlanLoading: 'Skaičiuojamas evakuacijos planas…',
    maintenancePlanError: 'Nepavyko įkelti evakuacijos plano — ištuštinimas vis tiek migruos, kur įmanoma, ir sustabdys likusias.',
    maintenancePlanEmpty: 'Šiame mazge nėra ko evakuoti — nėra aktyvios tinklo paslaugos, nėra veikti norimo App egzemplioriaus, nėra veikiančios VM.',
    maintenancePlanSummary: '{migrate} objektų migruos (VM, tinklo paslaugos, App egzemplioriai), {stop} sustos arba liks kur yra.',
    maintenancePlanReserve_ok: 'Failover rezervas po ištuštinimo: nepažeistas — lieka {headroom} GiB, kuriuos galima paleisti; toleruojama prarastų mazgų: {n}.',
    maintenancePlanReserve_eroded: 'Failover rezervas po ištuštinimo: beveik išnaudotas — iš {reserve} GiB, laikomų laisvų, liko tik {headroom} GiB; toleruojama mazgų gedimų: {n}.',
    maintenancePlanReserve_exhausted: 'Failover rezervas po ištuštinimo: IŠSEMTAS — trūksta {headroom} GiB iš {reserve} GiB, reikalingų toleruoti mazgų gedimus; toleruojama gedimų: {n}. Kol šis mazgas nedirba, nauji VM paleidimai bus atmetami.',
    maintenancePlanReserve_unknown: 'Failover rezervas po ištuštinimo: neapskaičiuojamas — nė vienas likęs mazgas nedeklaravo savo atminties.',
    maintenancePlanReserveHugePages: 'Milžiniški {size} puslapiai po ištuštinimo — laisvų: {free} iš {capacity}, rezervui reikia: {reserve}.',
    maintenancePlanActionMigrate: 'migruoja',
    maintenancePlanActionMigrateWarning: 'migruoja (pažeista minkštoji taisyklė)',
    maintenancePlanActionStop: 'sustoja',
    maintenancePlanActionBlocked: 'užblokuota',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'tinklo paslauga',
    maintenancePlanKindApp: 'App egzempliorius',
    maintenancePlanColdMove: 'Šaltas perkėlimas: podas čia sustabdomas ir nupjaunamas, o tikslinio mazgo worker jį sukuria iš naujo — prastova iki kito tikslinio workerio passo.',
    caFingerprint: 'Klasterio CA kontrolinis kodas',
    staleChip: 'nebeatnaujinta',
    troubleshootTitle: 'Store trikčių šalinimas',
    restartStore: 'Iš naujo paleisti store paslaugas',
    restartHint: 'Jei store išsidirbinėja, paleiskite jo paslaugas iš naujo. Pažengusiems — naudokite atsargiai.',
    restartQueued: 'Paleidimo iš naujo task įtrauktas į eilę',
    restartError: 'Nepavyko iš naujo paleisti paslaugų',
    svcActive: 'aktyvi',
    svcWanted: 'norima, bet neveikia',
    svcStopped: 'sustabdyta',
    noServices: 'Nepranešta apie jokias paslaugas'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Viso klasterio GPU inventorius, sugrupuotas pagal modelį — kiekviename mazge stebimos plokštės su pažymėtomis registracijomis ir jų žymomis',
    usbTitle: 'USB ištekliai',
    usbSubtitle: 'Viso klasterio USB inventorius, sugrupuotas pagal modelį — kiekviename mazge stebimi įrenginiai su abiejų modelių registracijomis (pagal įrenginį, pagal prievadą) ir jų žymomis',
    markedChip: 'naudojamų TVirt: {n}',
    orphanChipGpu: 'našlaičių: {n}',
    orphanChipUsb: 'našlaičių: {n}',
    colNode: 'Mazgas',
    colRegistration: 'Registracija',
      noRegsHint: 'Registracijų nėra — įrenginys pažymimas „naudojamas TVirt“ mazgo dialoge (Mazgai › mazgas › Nustatymai).',
      colDevice: 'Įrenginys',
      colObserved: 'Stebimi',
      colRegs: 'Registracijos',
      regsNone: 'nėra',
      colPci: 'PCIe adresas',
      colIdentity: 'Tapatybė / prievadas',
      colClasses: 'Klasės (žymos)',
      colActions: 'Veiksmai',
      manageOnNode: 'Tvarkyti mazge {node} (žymėjimas gyvena mazgo dialoge)',
      introTitle: 'Klasterio inventorius USB ir PCIe įrenginių, kuriuos gali naudoti TVirt©.',
      introStep1: '1. Mazgai patys aptinka savo GPU ir USB įrenginius (surašymas heartbeat pranešime).',
      introStep2: '2. Įrenginys pažymimas „naudojamas TVirt“ MAZGO dialoge (Mazgai › mazgas › Nustatymai) — žymėjimas susieja jį su vfio ir užregistruoja čia.',
      introStep3: '3. Čia registracijoms per žymas suteikiate jų KLASES (pvz., gpu_class=compute): VM reikalavimai prašys klasės, o planuoklis parinks mazgą su suderinamu laisvu įrenginiu.',
    colMode: 'Režimas',
    colState: 'Būsena',
    colNotes: 'Pastabos',
    colTags: 'Žymos',
    modeDevice: 'pagal įrenginį',
    modePort: 'pagal prievadą',
    usable: 'naudojamas',
    orphanGpu: 'našlaitė',
    orphanUsb: 'našlaitis',
    hubChip: 'hub',
    orphanPortsTitle: 'Registracijos pagal prievadą be prijungto įrenginio — prijunkite įrenginį arba nuimkite jų žymėjimą mazge',
    gpusEmpty: 'Nė viename mazge dar nestebėta jokia GPU',
    usbEmpty: 'Nė viename mazge dar nestebėtas joks USB įrenginys'
  },

  // Bendras nustatymų formų žodynas (2026-07-24 refaktoringas): saugumo laukai
  // maitina Klasterio puslapio kortelę, o mazgo laukai — node-settings puslapį;
  // /system/settings puslapis, dėl kurio jie gimė, yra miręs.
  settings: {
    passwordMinLength: 'Mažiausias slaptažodžio ilgis',
    sessionIdle: 'Seanso neveiklumo laikas (minutėmis)',
    lockoutThreshold: 'Užrakinti po nepavykusių bandymų',
    lockoutDuration: 'Užrakinimo trukmė (minutėmis)',
    keyboardLayout: 'Klaviatūros išdėstymas',
    keyboardLayoutHint: 'pvz., it, en-us — tuščia: numatytasis QEMU',
    syslogEndpoint: 'Syslog galinis taškas',
    syslogEndpointHint: 'hostas:prievadas — tuščia išjungia persiuntimą',
    syslogTls: 'TLS',
    maxQueued: 'Daugiausia task eilėje',
    concurrency: 'Worker lygiagretumas',
    concurrencyHint: 'Worker pritaiko skrydžio metu',
    notesTitle: 'Pastabos',
    save: 'Įrašyti',
    saved: 'Nustatymai įrašyti',
    saveError: 'Nepavyko įrašyti nustatymų'
  },
  localSettings: {
    derivedChip: 'išvestas',
    derivedTip: 'Šis device PRIKLAUSO fabric derivacijai (H2): redaktorius atsisako jį liesti — pakeiskite fabric (ar kabelius) ir pritaikykite iš naujo, arba atsiimkite jį žemiau.',
    takeOwnership: 'Perimti nuosavybę',
    takeOwnershipTitle: 'Perimti nuosavybę (take-ownership)',
    takeOwnershipConfirm: '{name} palieka fabric bloką ir vėl tampa RANKINIU device, kurį valdo šis redaktorius. Mazgas tampa nukrypusiu, ir kitas derivacijos apply jame atmes (manualConflict), kol jo nepervadinsite ar nepašalinsite — arba nepataisysite fabric.',
    nodeSettingsTitle: 'Mazgo nustatymai',
    nodeSettingsSubtitle: 'Ką taiko šis mazgas — task eilė, konsolė, žurnalų persiuntimas — bei jo žymos ir pastabos',
    baseTitle: 'Host rezervai (TVirt Proximity)',
    baseSubtitle: 'Host operacinei sistemai rezervuoti CPU ir RAM — empirinės talpos, pagal kurią Proximity išdėsto VM, įvestys',
    baseMemory: 'Bazinė RAM (MiB)',
    baseMemoryHint: 'Stebimas bendras kiekis: {total} MiB. Naudojama VM = bendras − bazinis − čia išdėstytų veikiančių VM RAM.',
    baseMemoryHintNoTotal: 'Naudojama VM = stebimas bendras kiekis − bazinis − čia išdėstytų veikiančių VM RAM.',
    baseCpu: 'Baziniai CPU branduoliai',
    baseCpuHint: 'Stebimi loginiai CPU: {total}. Naudojami tik kaip reitingavimo svoris — vCPU overcommit yra normalu.',
    baseCpuHintNoTotal: 'Naudojami tik kaip reitingavimo svoris — vCPU overcommit yra normalu.',
    baseHint: 'RAM yra griežti priėmimo vartai: netelpanti į naudojamą RAM VM atmetama su kalbančiu klaidos pranešimu. Padidinkite bazę hostuose, kuriuose gyvena store nariai ar Ceph demonai.',
    placementTitle: 'Fizinis išdėstymas',
    placementSubtitle: 'Kur fiziškai stovi šis serveris — deklaruojama vieną kartą, kad ir kam prireiktų',
    placementHint: 'Išdėstymas nurodo kiekvieno Ceph klasterio, turinčio OSD šiame serveryje, CRUSH hierarchiją: įrašius pakeitimą, jų žemėlapiai per task suderinami iš naujo (host → rack → … → root). Daliniai deklaravimai yra teisėti — tušti lygiai susitraukia. Pavadinimai bendri visame žemėlapyje: du to paties rack serveriai deklaruoja tą patį rack pavadinimą.',
    placementNameInvalid: 'DNS saugus pavadinimas (mažosios raidės, skaitmenys, brūkšneliai)',
    placementEmpty: 'Tuščia = nedeklaruota',
    placementLevel: {
      chassis: 'Korpusas',
      rack: 'Rack',
      row: 'Eilė',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Patalpa',
      datacenter: 'Duomenų centras',
      zone: 'Zona',
      region: 'Regionas'
    },
    cablingTitle: 'Kabeliavimas',
    cablingSubtitle: 'Prie kurio switch prievado prijungta kiekviena sąsaja — deklaracija gyvena mazge (Annex O.9)',
    cablingHint: 'Vienas kabelis vienai NIC, vienas kabelis vienam prievadui visame parke (API atmeta įvardydama savininką). Kabelį vesti į prievadą, esantį LAGG nariu, teisėta — tai bond atvejis: būsimas išvedimas pateiks jį kaip LACP.',
    cablingInterface: 'Sąsaja',
    cablingNotCabled: '— neprijungta —',
    cablingNoInterfaces: 'Nestebėta nė viena tinklo sąsaja',
    disksTitle: 'Diskai',
    disksSubtitle: 'Stebimi blokiniai įrenginiai — vienas nuskaitymas per suderinimo ciklą; čia pažymėkite diskus, tinkamus naudoti kaip Ceph OSD (N.15: tinkamumas deklaruojamas aiškiai)',
    colDataDisk: 'Duomenų diskas',
    dataDisksHint: 'Pažymėjus įrenginį, jis deklaruojamas tinkamu OSD; serijos numeris yra jo tapatybės kaištis — nukopijuotas iš aparatinės įrangos, kai diskas jį praneša, arba sukurtas (tvirt-…) kitu atveju. Ceph registracijos dialogas siūlo tik deklaruotus diskus.',
    diskDeclaredSerial: 'deklaruota',
    diskNotObserved: 'deklaruotas, bet nestebimas — prijunkite įrenginį iš naujo arba nuimkite žymėjimą',
    noDisks: 'Dar nestebėtas nė vienas blokinis įrenginys',
    colSerial: 'Serijos numeris',
    colModel: 'Modelis',
    colSize: 'Dydis (GiB)',
    colDiskType: 'Tipas',
    colInUse: 'Naudojamas',
    colObservedAt: 'Stebėta',
    diskInUse: 'naudojamas',
    diskFree: 'laisvas',
    diskMounted: 'prijungtas',
    diskPartitions: 'skaidiniai',
    passthroughTitle: 'Passthrough įrenginiai',
    passthroughSubtitle: 'Stebimos GPU ir USB įrenginiai — čia pažymėkite, ką TVirt gali perduoti VM; žymėjimas užregistruoja įrenginio tapatybę (U1+G1 raundai)',
    passthroughHint: 'Žymėjimas užregistruoja įrenginį (stabilus id — žymų ir klasės reikalavimų taikinys). Pažymėtos GPU VISA IOMMU grupė vienu ypu susiejama su vfio-pci — ji iškart palieka hostą; nuėmus žymėjimą, grąžinama savoji tvarkyklė. USB galioja abu ratifikuoti modeliai: pagal įrenginį (gamintojas+produktas, kad ir kur jis būtų prijungtas) ir pagal fizinį prievadą (VM gauna tai, kas į jį įkišta). USB su žymėjimu nesusiejamas — prijungimas įvyksta VM vykdymo metu.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Naudojamas TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI adresas',
    colDriver: 'Tvarkyklė',
    colVerdict: 'Verdiktas',
    gpuEligible: 'Tinkama',
    gpuIneligible: 'Netinkama',
    gpuReason: {
      'no-iommu': 'IOMMU hoste neįjungtas',
      'group-spans-slots': 'IOMMU grupė neizoliuota: apima kitus lizdus',
      'multiple-display': 'IOMMU grupė neizoliuota: daugiau nei viena vaizdo funkcija',
      'foreign-function': 'IOMMU grupė neizoliuota: joje yra svetima funkcija'
    },
    vfioNotReady: 'IOMMU šiame hoste neįjungtas: nė viena GPU nebus tinkama, kol host platforma jo neįjungs (OEM ISO) — TVirt niekada nekaišioja kernel args vykdymo metu.',
    vfioMissingKernelArg: 'IOMMU šiame hoste neįjungtas: firmware praneša VT-d/AMD-Vi (yra ACPI DMAR/IVRS lentelė), bet trūksta kernel arg — į branduolio komandinę eilutę įrašykite intel_iommu=on (Intel) arba pašalinkite amd_iommu=off (AMD) ir perkraukite. TVirt niekada nekaišioja kernel args vykdymo metu.',
    vfioFirmwareDisabled: 'IOMMU šiame hoste neįjungtas: VT-d/AMD-Vi išjungtas firmware (nėra ACPI DMAR/IVRS lentelės) arba CPU jo nepalaiko — įjunkite jį firmware sąrankoje, joks kernel arg jo neįžiebs. TVirt niekada nekaišioja hosto vykdymo metu.',
    gpuBindError: 'Nepavyko susieti vfio-pci ties {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Užkarda ant nevaldomų bridge',
    firewallBridgesSubtitle: 'Šiame mazge ranka sukurti bridge, kurių sąranka sutinka su TVirt generuojamomis užkardos chain ant prijungtų svečių NIC',
    firewallBridgesHint: 'TVirt niekada neliečia svetimo bridge — chain įsitvirtina ant tap/veth, kuris visada priklauso TVirt. Sąrašas yra sutikimo vartai: default-deny ir anti-spoof gali sulaužyti tai, ko tikisi rankinė sąranka, todėl NIC su užkarda ant nevaldomo bridge, kurio ČIA nėra sąraše, atmetama su kalbančia klaida.',
    firewallBridgesEmpty: 'Nė vienas nevaldomas bridge šiame mazge nesutinka su TVirt generuojamomis užkardos chain.',
    firewallBridgeAdd: 'Pridėti bridge',
    firewallBridgeInvalid: 'Ne Linux sąsajos vardas (1-15 simbolių, be pasvirojo brūkšnio ir tarpų)',
    firewallBridgeDuplicate: 'Vardas jau sąraše',
    colMarkDevice: 'Pagal įrenginį',
    colMarkPort: 'Pagal prievadą',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Prievadas',
    passthroughOrphan: 'našlaitis — užregistruotas, bet nebeaptinkamas: prijunkite jį iš naujo arba nuimkite žymėjimą',
    noGpus: 'Dar nestebėta nė viena GPU',
    noUsb: 'Dar nestebėtas nė vienas USB įrenginys',
    networkGeneration: 'Tinklo generacija',
    applied: 'Pritaikyta',
    converged: 'suderinta',
    behind: 'atsilieka — {m} / {n}',
    notConfigured: 'nesukonfigūruota',
    rollbackBody: 'Nepavyko pritaikyti {gen} generacijos: {error}',
    rolledBackChip: 'atliktas rollback',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Valdomų NIC registras — registracija YRA valdymo deklaracija: užregistruota NIC be konfigūracijos neliečiama (clear-if ją aiškiai paskelbia švaria), o neužregistruotas įrenginys neliečiamas niekada',
    addNic: 'Registruoti NIC',
    addNicTitle: 'Registruoti NIC (add-nic)',
    delNic: 'Nutraukti valdymą',
    delNicTitle: 'Nutraukti valdymą (del-nic)',
    delNicConfirm:
      '{name} valdymas nutraukiamas: registro įrašas ir jo konfigūracija ištrinami, o TVirt profilis pašalinamas — įrenginys lieka toks, kokį jį paliko Linux.',
    nicName: 'Įrenginio pavadinimas',
    nicMac: 'Nuolatinis MAC adresas',
    nicMacHint: 'nuolatinis aparatinis MAC — stabili tapatybė, nustatyta TVirt Server Installer',
    colObserved: 'Stebima',
    nicObserved: 'stebima',
    nicNotObserved: 'nestebima',
    nicMacMismatch: 'MAC nesutampa — stebimas {mac}',
    noNics: 'Neužregistruota nė viena NIC — užregistruokite įrenginį, kad pradėtumėte jį valdyti',
    noManagedDevices: 'Nėra valdomų įrenginių — pirma užregistruokite NIC, viskas statoma ant registro',
    inventoryTitle: 'Stebimi įrenginiai',
    inventorySubtitle: 'Atnaujinami kiekvieno mazgo worker suderinimo ciklo metu — validacija tikrina įrenginių pavadinimus pagal šį inventorių',
    colDevice: 'Įrenginys',
    colType: 'Tipas',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Greitis',
    colTopology: 'Topologija',
    colMtu: 'MTU',
    colAddresses: 'Adresai',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP neagreguoja',
    noInventory: 'Kol kas nepranešta apie jokį įrenginį',
    interfacesTitle: 'Sąsajos',
    interfacesSubtitle:
      'Užregistruotų NIC ir deklaruotų loginių įrenginių L3 konfigūracija — set-if pakeičia visą bloką, edit-if pakoreguoja savybes, clear-if jį ištuština (aiškus išvalymas)',
    colConfig: 'Pageidaujama konfigūracija',
    clean: 'švari',
    setIf: 'Keisti adresavimą',
    setIfTitle: 'Keisti adresavimą (set-if)',
    editIf: 'Keisti savybes',
    editIfTitle: 'Keisti savybes (edit-if)',
    clearIf: 'Ištuštinti konfigūraciją',
    clearIfTitle: 'Ištuštinti konfigūraciją (clear-if)',
    clearIfConfirm: 'Sąsajos konfigūracija ištuštinama. Švari sąsaja yra būtina sąlyga, kad ją būtų galima pajungti kaip bond ar bridge narį arba kaip VLAN parent.',
    ip4Mode: 'IPv4 režimas',
    ip6Mode: 'IPv6 režimas',
    modeUnconfigured: 'Nesukonfigūruota',
    modeStatic: 'Statinė',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 adresai',
    ip6Addresses: 'IPv6 adresai',
    addressesHint: 'CIDR, atskirti kableliais',
    gw4: 'IPv4 šliuzas',
    gw6: 'IPv6 šliuzas',
    dns: 'DNS serveriai',
    dnsHint: 'atskirti kableliais — tuščia išvalo DNS (set-if pakeičia bloką)',
    routes4: 'Statiniai IPv4 maršrutai',
    routes6: 'Statiniai IPv6 maršrutai',
    routeTo: 'Paskirtis (CIDR)',
    routeVia: 'Per',
    addRoute: 'Pridėti maršrutą',
    routesChip: 'maršrutai',
    mtu: 'MTU',
    mtuHint: 'tuščia = numatytoji tvarkyklės',
    vlansTitle: 'VLAN',
    addVlan: 'Pridėti VLAN',
    addVlanTitle: 'Pridėti VLAN (add-vlan)',
    delVlanTitle: 'Šalinti VLAN (del-vlan)',
    vlanParent: 'Parent sąsaja',
    vlanId: 'VLAN ID',
    vlanPreview: 'Įrenginio pavadinimas',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Nedeklaruotas nė vienas VLAN',
    bondsTitle: 'Bond',
    addBond: 'Pridėti bond',
    addBondTitle: 'Pridėti bond (add-bond)',
    editBondTitle: 'Redaguoti bond',
    editBond: 'Įrašyti bond',
    delBondTitle: 'Šalinti bond (del-bond)',
    bondName: 'Bond pavadinimas',
    members: 'Nariai',
    membersHint: 'nariai turi būti švarios sąsajos (be L3 konfigūracijos)',
    bondMode: 'Režimas',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Pirminis narys',
    rate: 'LACP rate',
    hash: 'Perdavimo maišos politika',
    colMembers: 'Nariai',
    colMode: 'Režimas',
    noBonds: 'Nedeklaruotas nė vienas bond',
    bridgesTitle: 'Bridge',
    addBridge: 'Pridėti bridge',
    addBridgeTitle: 'Pridėti bridge (add-bridge)',
    editBridgeTitle: 'Redaguoti bridge',
    editBridge: 'Įrašyti bridge',
    delBridgeTitle: 'Šalinti bridge (del-bridge)',
    bridgeName: 'Bridge pavadinimas',
    stp: 'STP',
    stpOn: 'STP įjungtas',
    stpOff: 'STP išjungtas',
    colStp: 'STP',
    noBridges: 'Nedeklaruotas nė vienas bridge',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Nustatyti hostname',
    setHostnameTitle: 'Nustatyti hostname (set-hostname)',
    hostnameHint: 'Tik OS tapatybė — mazgo pavadinimas klasteryje neliečiamas',
    notSet: 'nenustatyta',
    staticHostsTitle: 'Statiniai host įrašai',
    addStaticHost: 'Pridėti įrašą',
    addStaticHostTitle: 'Pridėti statinį host įrašą',
    delStaticHostTitle: 'Šalinti statinį host įrašą',
    hostIp: 'IP adresas',
    hostNames: 'Vardai',
    hostNamesHint: 'atskirti kableliais arba tarpais',
    colIp: 'IP',
    colNames: 'Vardai',
    noStaticHosts: 'Nėra statinių host įrašų',
    delConfirm: '{name} šalinamas iš pageidaujamo dokumento — mazgo worker suderina su NetworkManager kontroliniu tašku ir automatiniu rollback.',
    remove: 'Pašalinti',
    opError: 'Tinklo operacija buvo atmesta'
  }
}
